import { WidgetType } from '@enums/WidgetType'

export const deepLinkConfig = {
  [WidgetType.FASTAG]: 'acko.com://fastag_lookup',
}
